export const INITIAL_CONFIG = 'INITIAL_CONFIG'

export const PAGE_SELECTED_LAST = 'PAGE_SELECTED_LAST'